<template>
  <div style="text-align: left;">
    <div
        style="padding:8px;background-color:#EEECED;width:100%;display:flex;align-items:center;justify-content:center;">
      <img :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'" alt="" style="width:30%;"></div>
    <div style="position:relative;"><img src="img/c1.png" alt="" style="width:100%;">
      <div style="color:#fff;font-size:1.5rem;position:absolute;bottom:60px;left:50%;transform:translateX(-50%);"> Incontri di alta qualità...
      </div>
      <div style="color:#fff;font-size:1.2rem;position:absolute;bottom:22px;left:50%;transform:translateX(-50%);">
        ❤️ {{ this.$store.getters.getBaseInfo.name }} Club
      </div>
    </div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p style="font-weight:bold;"> Hai mai avuto una comunicazione soddisfacente nella precedente app o nel gruppo di amici?</p>
      <p>Non sei stanco delle donne che si preoccupano solo dei marchi e dei soldi?</p>
      <p> Non vorresti sostenere le donne che inseguono davvero i propri sogni?</p>
      <p>Avete mai incontrato una donna che emana bellezza in ogni suo aspetto, nel corpo e nella mente?</p>
      <p> ❤️ {{ this.$store.getters.getBaseInfo.name }} I club di incontro possono risolvere le preoccupazioni degli uomini e realizzare i loro desideri.</p></div>
    <div><img src="img/c2.png" alt="" style="width:100%;"></div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p style="font-weight:bold;"> Per quanto belle donne ci siano, le donne buone, degne di essere amate, sono poche e rare.</p>
      <p> I grandi uomini hanno già sperimentato quante bellezze ineguagliabili, di un calibro completamente diverso, esistano in questo mondo. Anche se le inseguiste e le possedeste, ciò che otterreste dalla borsa Birkin sarebbe un vuoto nel vostro cuore. </p>
      <p>Non importa quanto sia bella una donna, se ti stanchi di lei da un giorno all'altro, non sarà mai una "brava donna" ❤️ {{ this.$store.getters.getBaseInfo.name }}  Sperimenta in prima persona gli "standard" definiti da [Nome].  </p>
      <p> Cosa dovrebbe fare un uomo che vuole essere amato, vuole mettersi in mostra, vuole andare a letto con una bella donna... e gioca con le donne? </p>
      <p>Questo messaggio è per gli uomini che sanno quanto sia incredibile il potere di una "donna a cui non riesci a smettere di pensare". Non chiederò alcun compenso per la segnalazione finché non ci incontreremo e non avremo verificato la compatibilità. Per favore, dimmi onestamente che tipo di donna vorresti incontrare.</p></div>
    <div><img src="img/c3.png" alt="" style="width:100%;"></div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p style="font-weight:bold;">Quello che hai costruito</p>
      <p>Non sprecherò il tuo tempo e il tuo denaro.</p>
      <p>Sai cosa considera più importante il nostro ❤️ {{ this.$store.getters.getBaseInfo.name }} Concierge del Club?</p>
      <p>È semplice. Si tratta della "sensazione (compatibilità)" tra le due persone.</p>
      <p>Ciò che apprezziamo di più è la compatibilità. Pertanto, chiediamo che gli uomini incontrino prima la donna e si facciano un'opinione.</p>
      <p>Se avverti anche il minimo accenno di qualcosa di diverso, puoi tranquillamente rifiutare. Ti assicuriamo che non ci sarà alcun costo in caso di rifiuto.</p>
      <p>Molti membri affermano che "sprecare tempo è il peccato più grande".</p>
      <p>Il nostro obiettivo è offrire quante più opportunità possibili anche solo a una persona in più.</p>
      <p>Credo che l'incontro con un uomo che corrisponda ai suoi gusti o che si avvicini alla sua donna ideale dipenda da come si sfrutta questo tempo prezioso.</p>
      <p>Non offriamo mai riunioni che facciano perdere tempo e denaro. Questa è la nostra promessa.</p></div>
    <div style="padding:12px;"><h2 style="background-color:#e62978;text-align:center;line-height:2;"><strong><span
        style="font-size:20px;"><span style="color:#ffffff;">Introduzione delle socie</span></span></strong></h2></div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p>Vi offriremo la migliore corrispondenza tra innumerevoli donne.</p>
      <p>Vengono registrate solo le donne che hanno superato i colloqui, dimostrando di possedere determinati standard di aspetto e raffinatezza, permettendoti così di avere appuntamenti con membri di alto livello, nettamente superiori a quelli offerti dagli altri siti di incontri.</p>
      <p>Molte donne, tra cui modelle e artiste, sono affiliate all'agenzia di spettacolo e possiedono bellezza ed eleganza.</p>
      <p>Goditi un appuntamento speciale con una donna che normalmente non avresti l'opportunità di incontrare.</p>
      <p>È possibile utilizzarlo ovunque nel paese, anche durante un viaggio di lavoro.</p></div>
    <div style="padding: 12px;">

      <swiper class="van-swipe"   :options="bannerSwiperOption">
        <swiper-slide v-for="(v,key) in list" :key="key">

          <div style="display: flex; padding: 8px 12px; border: 3px solid rgb(230, 41, 120); border-radius: 12px;">
            <img :src="v.url" alt="" style="width: 25%; border-radius: 12px;">
            <div style="flex: 1 1 0%; padding-left: 12px; display: flex; flex-direction: column; justify-content: space-between;">
              <div><span style="padding: 4px 8px; background-color: rgb(230, 41, 120); border-radius: 8px; color: rgb(255, 255, 255); font-size: 1.2rem; font-weight: bold;">{{ v.address }}</span>
              </div>
              <div> {{ v.title }}</div>
              <div style="color: rgb(136, 136, 136);">{{ v.content }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

    </div>
    <div style="background-color:#DBE6F1;padding:12px;">
      <div style="display:flex;column-gap:12px;">
        <img src="img/step1.png" alt=""
                                                      style="width:30%;object-fit:cover;border-radius:8px;"><img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAM1BMVEUAAAAhR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3oOmH6fAAAAEHRSTlMAwIBAEKDQ8OAgYFCQcDCwETUB1AAAA2lJREFUWMOtmOvabiAQhs1MaY/zP9ol7XzKK1nzAxd1m2dmSpk6TBFpRDREbPpqi1vn7WzAtRqmGS62lkm7DNCUjbQ207GXOF46z4DoiAjRgsx3BbIRHCD9fcSMnV8jUUTXdLuHQhmFm67ERg/4r8gbCI3WZyddxD0VBwWkoId2PIilDik6REb/asOCXJy6jK1BzBNPxuB1O8l/84C9GZoyEtu83wJed1oHeInoGk9s5I0RTV2qkTdIFOp6V/jym4ZM+b7QCKAYnZCpDqMJcRg1W4n25WSncfNhXKdimAV/EU1/M6IvWSIiNSlDqovIY17KlCUbVbkRbskonkV8JPgfRcrfW84R1BcJYMjNi/dz3hyZvfsOJULuX8bdei0UfipjUzvITwGBcL0Dc8TxkDBVLrJSg+4KXNlvIBXglcICu8oapysQdyseynrszvlqrSY6yGkrQNjtAALyTVznYV8qKoVTtz6WYtM3kiWAq8opc2SlOHeE+xjWZmKeVWuaUaHFKyCLxWJaw1hKi1Ye04WvQ8+nIymrVMt6swiYg1RshVBLnxNzOLib9udoyu4Hezf8KJ2+W3bN18cooi5e3JX/P2DIRkryd2NhLIRjy1xYmVhWSg0BwNwSfwOXtFItgyzcwTEgk3soDBkPkcllnMeBfOex9BnXpXi7gHPDQeExZYgmgwpYJaUqm4xh5b3PwFI27cLGPXJFpegG4t3Qg+JWeWMNrIdeOn0HRteS8u/AnA3m0/wZmEH1J6AGXrLMa1apryRdN4CyXK7Vi2ornPozWnRGBdgDFF5pvlKNJaTJa4ylA6i9X8VXbDyGhIZWbFuadKlw2VrEcxXKlDqA6rxmlR5e5SxZeeQQ96YSEdsp4Wd9srm68cKXU9iTtRw8J0I2d1eMqPvfz5ocLC5+X7Sry7ZiHecxed3X0X/Y+LB6a7YM8nTcmtWbx7EwLnnzWImGoQCKdkrx0wac7n7Z8DGevp3CN/4ujuroZG9f9jYzS8+PG0HdPPf4a4lv3izrkxumD/dQ894k9bgnDj36oZkRBxKekFqG/3hLr5ANzI/Q7LgUnD4tQTiqdmp5akC9xWrLL2uj/sJ0om3CvalX3y11hBWDAWzZJLKXQ8rJ7d5AD01Ldm7TnJpGTWkL4sSSgIZNn22hYD2O/QOEGEqZt4auNAAAAABJRU5ErkJggg=="
          alt="" style="width:10%;height:10%;">
        <div style="flex:1;">
          <div style="line-height:1.5rem;font-size:1.2rem;font-weight:bold;color:#21477A;">Collocamento</div>
          <div style="font-size:.8rem;">Il nostro club facilita gli "appuntamenti", ovvero i contatti tra i clienti e le donne iscritte. Vi preghiamo di richiedere un appuntamento con la donna iscritta che desiderate incontrare.</div>
        </div>
      </div>
      <div style="display:flex;column-gap:12px;padding-top:12px;">
        <img src="img/step2.png" alt=""
                                                                       style="width:30%;object-fit:cover;border-radius:8px;"><img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAM1BMVEUAAAAhR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3oOmH6fAAAAEHRSTlMAwIBAEPCgMGDQIOCQUHCwx+vuvgAAA3tJREFUWMOtWFmi2yAMNPsOuv9pmxiIGgscQzsfL882DGLQAhwPYYQ//guM5cxBBys8/QOxtFoBRYhpi05omELFZTttAIRjTHPGWAAEE3t07Fs0Y6NbpxS9T7HyoPD58/3RxGVs2nNkI5xttVR+4Ceu0tkfw/JKWeQv9c52Cq27sbKObG5b8Sq3f6Z1OAe/88o6aH7s+bW9vedTZsW/CCPhc3It1tWckSPfMuPIxxPyrTMqP3i/xTfv6XCcBeDc4khAsUo172zer/ixC/YOGXl9445teIX2oArm2Ee+rECYTVjKhUnrrwBS313TKYLMAKzCtN9y5PNXf0eHgBf8h54Y6CFEXiAJznkAzXUwAuD1wMLhC7ii0FEoh6EGRkjvCdemzSMAupe8exYAYqLqvalfFrR4QpgAaGS01Khw+n+pyhIhFC90wgyKZrLSjaU+yNW7EFwI3zgJtbDhmodl/dpmnAf7EAcgJlMGnACi9Dm7PmPaQs80nGXv2EwN4yIEbIXQN+kE+jiC6SQSA04WxWp5REKI8dYUybS8fHJcz0PQYMpbwbFEp+pxmAiNEGInLaYaMyQFbGduXgmP/wJRCckib8NXcevfETxnL0TRZc2xJrA8q2U/CCM0sJ51Psg7hAVARR7V5zsHKFbYk1esE+a2bTKq95c8y14/4jphAOAYorTfnDAM3cZ8MoYk/cOIsAcx+iH1euwfrt7Bb/ywDEtyQStwRHw2s+KcewRewaaEerImLSu0CHxM6N0o22FDWeVnTwmTQvsIeiF9t/lB6P7ewqSb3FCwuFBCR7g1xiEFFjv7pQqdp+saR9KQVADfPVeNaoD5OHYi9ZvC4OcyOGlgwNru1/p+06zRW+xgnX0/zxjVRsMY9ZbRhZF1Q4P/i+ExSDPU7UyNL6j2irZnlweyuzmhOC5OBXFFYpQf5kxpudbcSqysiKGBAR/jRqWikqeLwfzYB7uKljfPFfPuDg+Am8fHSP0c9B6fdO1kRq3mmwJOkj5G4BL0pPRLt8eop2J5hYyLfO7uPiIurQcjNxWUkcnn/hKQ76aBEiv+TA2gKwNaPjGPwRPn1Zizft57PVvEpPA+8ueNpDNPVq60zKpnrdO7xUpkiYBX1vJqG15uM7916+wKt6IicxZ27p3xFmMOvUBHr5cReB29CBTsSspQ1l0IwRuy+O0lfwDAnU0yiUzkbwAAAABJRU5ErkJggg=="
          alt="" style="width:10%;height:10%;">
        <div style="flex:1;">
          <div style="line-height:1.5rem;font-size:1.2rem;font-weight:bold;color:#21477A;">data</div>
          <div style="font-size:.8rem;"> Dopo aver conosciuto una donna iscritta al registro, sei libero di frequentarla come preferisci. Per la vostra futura relazione, stabilisci le tue regole e goditela.</div>
        </div>
      </div>
    </div>
    <div style="padding:12px;"><h2 style="background-color:#e62978;text-align:center;line-height:2;"><strong><span
        style="font-size:20px;"><span style="color:#ffffff;">La voce del cliente</span></span></strong></h2></div>
    <div style="padding: 12px;">

      <swiper class="van-swipe"   :options="bannerSwiperOption">
        <swiper-slide v-for="(v,key) in list1" :key="key">


          <div style="padding: 8px 12px; border: 3px solid rgb(230, 41, 120); border-radius: 12px;">
            <div style="display: flex;">
              <img :src="v.url" alt=""
                   style="width: 40%; border-radius: 12px;">
              <div style="flex: 1 1 0%; padding-left: 12px;">
                <div style="line-height: 1.5rem; font-weight: bold;">{{ v.name1 }}</div>
                <div style="line-height: 2rem; font-weight: bold;">{{ v.name2 }}</div>
                <div style="line-height: 1.2rem; color: rgb(230, 41, 120); font-weight: bold;">
                  {{ v.name3 }}
                </div>
              </div>
            </div>
            <div style="padding: 8px;">
              {{ v.name4 }}
            </div>
          </div>
        </swiper-slide>
      </swiper>

    </div>
    <div><img src="img/foot.png" alt="" style="width: 100%;"></div>
    <div style="height: 20px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {

      list1:[
        {
          name1: "Maschio di 51 anni",
          name2: "Proprietario dell'azienda",
          name3: "Sono la prima donna che ho incontrato, ma il gusto era molto giusto.",
          name4: "Sono impegnato ogni giorno, quindi non ho l'opportunità di conoscere le persone. Dal primo incontro, la ragazza è così amante del cuore e intelligente. Ero così amichevole, come un vecchio amico, un avversario completamente destino!",
          url:"img/k1.jpg"
        },
        {
          name1: "42 anni maschio",
          name2: "Avvocato",
          name3: "Sono stato in grado di godere della protezione della privacy.",
          name4: "A causa del mio lavoro, ho preso molto sul serio la privacy, quindi sono stato un po 'attento a unirmi a un sito del genere, ma anche la struttura del sito era dettagliata. È stato così bello. Mi sto divertendo con Lee Sang-hyung.",
          url:"img/k2.jpg"
        },
        {
          name1: "Maschio di 38 anni",
          name2: "Lavoro dell'agenzia pubblicitaria",
          name3: "È una grande attrazione che puoi divertirti ogni volta.",
          name4: "L'ho usato alcune volte, ma molti tipi di ragazze sono davvero attraenti. È stato bello incontrarsi così. L'ho assaggiato. Ho parlato con chiunque vivesse all'estero, ma l'ho perso davvero. Mi sono divertita.",
          url:"img/k3.jpg"
        },
        {
          name1: "55 anni maschio",
          name2: "Dirigente della società di costruzioni",
          name3: "Sembra una nuova vitalità della mia vita. Ogni giorno è gratificante.",
          name4: "Ho vissuto come un lavoro, ma sto passando una giornata con qualcosa di diverso, conoscendo le donne sulla nostra piattaforma. È particolarmente bello parlare con una donna in un altro settore. Gli orizzonti si sono ampliati e la vita è diventata più colorata.",
          url:"img/k4.jpg"
        },
        {
          name1: "46 anni maschio",
          name2: "Rappresentante del marchio di moda",
          name3: "E sono più colpita di quanto mi aspettassi. Ho avuto molto tempo.",
          name4: "Penso che qui sia un fascino poter incontrare donne così, ma non mi sentivo molto come la prima persona perché non avevano gli stessi valori. La seconda donna è troppo ideale, quindi stiamo programmando un viaggio all'estero. Il personale è affatto buono e le donne sono di qualità e completamente soddisfatte. È tutto.",
          url:"img/k5.jpg"
        },
        {
          name1: "38 anni donna",
          name2: "Personale dell'ufficio",
          name3: "Sembra essere un posto molto migliore di quanto pensi",
          name4: "Non c'era sensazione di ansia, ma il personale era traboccante, quindi era completamente sicuro da usare. Tutti gli uomini sono pieni di gentilezza.",
          url:"img/k6.jpg"
        },
        {
          name1: "32 anni donna",
          name2: "Freelance",
          name3: "E l'incontro con nuove persone è diventato la vitalità di una nuova vita.",
          name4: "Lavoro in un'attività difficile con un uomo, ma ora è un grande vantaggio parlare così comodamente. Tutti sono buoni e buone maniere. Ci stiamo adattando di più alla nostra gente. Lo stiamo usando in modo soddisfacente.",
          url:"img/k7.jpg"
        },
        {
          name1: "Donna di 28 anni",
          name2: "Dipendenti",
          name3: "Hilling del cuore viene",
          name4: "È una strana personalità, ma penso che gli uomini qui possano riunirsi e agire comodamente. Voglio fare un buon incontro qui e godermelo esilarante.",
          url:"img/k8.jpg"
        },
        {
          name1: "49 anni donna",
          name2: "Industria dei servizi",
          name3: "Ho un'esperienza piacevole che non dimenticherò mai.",
          name4: "Non mi aspettavo molto, ma voglio godermi i miei hobby e divertirmi in futuro.",
          url:"img/k9.jpg"
        }
      ],

        list:[
          {
            address: "Seul",
            title: "Vera pura bellezza",
            content: "Corpo simile a un modello",
            url:"img/hy1.jpg"
          },
          {
            address: "Daegu",
            title: "Donna carina con un sorriso attraente",
            content: "Un fascino illimitato",
            url:"img/hy2.jpg"
          },
          {
            address: "Busan",
            title: "Anche oltre i vestiti",
            content: "Glamer Curve è un modello",
            url:"img/hy3.jpg"
          },
          {
            address: "Daejeon",
            title: "Gambe calde rispetto alla ragazza da corsa",
            content: "",
            url:"img/hy4.jpg"
          },
          {
            address: "Incheon",
            title: "Una donna in un high-tech",
            content: "Anche se sembri freddo all'esterno, il cuore è caldo.",
            url:"img/hy5.jpg"
          },
          {
            address: "Ulsan",
            title: "Voglio che qualcuno condivida qualcosa di delizioso.",
            content: "",
            url:"img/hy6.jpg"
          }
        ],
        bannerSwiperOption: {
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          speed: 800,
          autoplay: true,
          coverflowEffect: {
            rotate: 50,
            stretch: 10,
            depth: 100,
            modifier: 1,
            slideShadows: true
          }
        }
    }
  }
}
</script>

<style scoped>

</style>
